export default {
  "title": "Crop image",
  "description": "Drag to reposition. Use the slider to zoom.",
  "save": "Save",
  "saving": "Saving…",
  "pickerHelp": "Drag & drop or choose an image to start.",
  "chooseImage": "Choose image",
  "canvasUnavailable": "Canvas context unavailable.",
  "normalizeFailed": "Failed to normalize image.",
  "generateFailed": "Failed to generate image.",
  "loadFailed": "Unable to load image.",
  "selectCrop": "Select a crop area to continue.",
  "stillLoading": "Image is still loading.",
  "cropFailed": "Unable to crop image.",
  "closeCropper": "Close image cropper",
  "close": "Close",
  "dropImage": "Drop an image here",
  "loading": "Loading image…",
  "zoom": "Zoom",
  "preview": "Preview",
  "previewAlt": "Cropped preview",
  "adjustCrop": "Adjust crop",
  "reset": "Reset",
  "cancel": "Cancel",
  "outputLimit": "Output size capped at {{size}}px.",
  "cropAvatar": "Crop avatar",
  "cropBotAvatar": "Crop bot avatar",
  "cropEmailLogo": "Crop email logo",
  "cropLogo": "Crop logo",
  "upload": "Upload",
  "logoDescription": "Drag to reposition and use the slider to zoom. The result is resized for use as a brand logo.",
  "botDescription": "Drag to reposition and use the slider to zoom. The result is cropped to a square so it renders cleanly as your QBxBot avatar.",
  "emailDescription": "Drag to reposition and use the slider to zoom. The result is resized for use in email headers.",
  "errorTitle": "Cropper error",
  "applyCrop": "Apply crop",
  "cropCollapsedLogo": "Crop collapsed logo",
  "cropFullLogo": "Crop full logo",
  "cropDefaultAvatar": "Crop default avatar",
  "cropDefaultBanner": "Crop default banner"
} as const;
